import React from 'react';
import { mergeTests } from '../../../ui-toolkit/test-utilities/mergeTests';
import { IParentComponent } from '../../../tailwindComponents/interfaces/IParentComponent';

export const NewOrderSpaceWrapping: React.FC<IParentComponent<HTMLDivElement>> = ({ children, ...rest }) => {
  return (
    <div data-test-id={mergeTests('new-order-space-wrapper', rest['data-test-id'])} className={'px-3 pb-0 pt-3'}>
      {children}
    </div>
  );
};
